import { ReactNode, useEffect, useRef, useState } from "react"

import { Paper, Fab } from "@mui/material"
import { Box } from "@mui/system"
import { Close as CloseIcon, Menu as MenuIcon } from "@mui/icons-material"

import { SIDEBAR_WIDTH } from "constants/sizing"

type CollapsibleDrawerProps = {
  children: ReactNode
}

export const CollapsibleDrawer = ({ children }: CollapsibleDrawerProps) => {
  const [open, setOpen] = useState(true)
  const childrenContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // When the drawer is closed, the interactive elements should be disabled or not reachable
    if (childrenContainerRef.current) {
      if (open) {
        childrenContainerRef.current.removeAttribute("inert")
      } else {
        childrenContainerRef.current.setAttribute("inert", "true")
      }
    }
  }, [open])

  const onToggleDrawer = () => {
    setOpen(!open)
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        transition: "all 0.3s ease",
      }}
    >
      {/* Navigation Container */}
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: SIDEBAR_WIDTH,
          transition: "width 0.3s ease",
          overflow: "hidden",
          paddingTop: 3,
          ...(!open && {
            width: 0,
            visibility: "hidden",
          }),
        }}
      >
        <div ref={childrenContainerRef}>{children}</div>
      </Paper>
      {/* Expand/Collapse Button */}
      <Fab
        onClick={onToggleDrawer}
        sx={{
          transition: "left 0.1s ease, width 0.1s ease, height 0.1s ease",
          transform: "translateX(-50%)",
        }}
        color={"primary"}
        {...(open
          ? { title: "Collapse Menu", size: "small" }
          : {
              title: "Expand Menu",
              size: "large",
            })}
      >
        {open ? <CloseIcon fontSize="small" aria-hidden /> : <MenuIcon aria-hidden />}
      </Fab>
    </Box>
  )
}
